import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=7bfd28a6&scoped=true&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"
import style0 from "./Wordpress.vue?vue&type=style&index=0&id=7bfd28a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd28a6",
  null
  
)

export default component.exports